'use client'

import React, { ReactNode } from 'react'
import clsx from 'clsx'
import ArrowIcon from '@/components/Shared/ArrowIcon'
import styles from './styles.module.scss'

interface CustomAccordionProps {
  title: string
  isExpanded: boolean
  onToggle: () => void
  children: ReactNode
  used?: string
  titleClassName?: string
}

export default function CustomAccordion({
  title,
  isExpanded,
  onToggle,
  children,
  used,
  titleClassName = '',
}: CustomAccordionProps) {
  const wrapperClass = clsx(styles.expansionPanel, used && styles[used])

  return (
    <div className={wrapperClass}>
      <button className={clsx(styles.accordionHeader, titleClassName)} onClick={onToggle}>
        <span>{title}</span>
        <ArrowIcon isExpanded={isExpanded} />
      </button>
      {isExpanded && <div className={styles.accordionContent}>{children}</div>}
    </div>
  )
}
